module.exports = __webpack_public_path__ + "assets/img/LTC046.3aeeb072.png";